import { z } from 'zod';

// Zod's optional JIT probes new Function, which emits a CSP violation even
// when the exception is caught. Use its interpreted parser in the browser.
z.config({ jitless: true });

// Schema modules import this configured instance so production chunk ordering
// cannot construct their objects before the CSP-safe setting takes effect.
export { z };
